import { FC } from 'react';
import { compose } from 'redux';
import { injectAnalyticsScope, injectReducer, injectTranslations, withTitle } from 'ia-react-core';
import en from './translations/en';
import fr from './translations/fr';
import { SecuredMessagingState } from '../../interfaces/SecuredMessagingState';
import SecuredMessagingPage, { SecuredMessagingPageProps } from './SecuredMessagingPage';
import { SecuredMessagingPageActions } from './SecuredMessagingPage.actions';
import securedMessagingPageReducer from './SecuredMessagingPage.reducer';

const initialState: Partial<SecuredMessagingState> = {
  selectedMessages: [],
};

export default compose<FC<SecuredMessagingPageProps>>(
  injectTranslations('SecureMessagingPage', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  withTitle('SecureMessagingPage:title'),
  injectReducer<SecuredMessagingPageProps, SecuredMessagingState, SecuredMessagingPageActions>({
    key: 'features.securedMessaging.list',
    reducer: securedMessagingPageReducer,
    initialState,
    useScope: true,
    cleanState: true,
  }),
  injectAnalyticsScope({
    key: 'SecureMessagingPage',
  }),
)(SecuredMessagingPage);
